import { frontendURL } from '../../../../helper/URLHelper';
import {
  AGENT_BOT_PERMISSIONS,
  INBOX_PERMISSIONS,
  INTEGRATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/connections'),
      component: SettingsWrapper,
      meta: {
        connectionsNavigation: true,
        connectionSection: 'home',
      },
      children: [
        {
          path: '',
          name: 'settings_connections_home',
          component: Index,
          meta: {
            permissions: [
              'administrator',
              INBOX_PERMISSIONS,
              AGENT_BOT_PERMISSIONS,
              INTEGRATION_PERMISSIONS,
            ],
          },
        },
      ],
    },
  ],
};
